"use strict";
/* eslint-disable @typescript-eslint/ban-types */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = void 0;
// TODO: Replace Function with specific type.
const uuid_1 = require("uuid");
// Codes carried by the domain exception classes the app routes on
// (ForceLogoutException, SyncException, OfflineTimeoutException). NetworkManager
// raises the latter two from inside an ON_AUTHENTICATE_SUCCEEDED observer and
// relies on them travelling out as a rejection, which the app turns into a
// reload or a return to the org listing. They are control flow, not failures, so
// notify() must let them past rather than report them.
const DOMAIN_SIGNAL_CODES = ["FORCE_LOGOUT", "SYNC_ERROR", "OFFLINE_TIMEOUT"];
const isDomainSignal = (error) => { var _a; return DOMAIN_SIGNAL_CODES.includes((_a = error === null || error === void 0 ? void 0 : error.code) !== null && _a !== void 0 ? _a : ""); };
class Observable {
    constructor() {
        this.observers = [];
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new Observable();
        }
        return this.instance;
    }
    subscribe(key, func) {
        if (!key) {
            throw Error("No key is present");
        }
        const id = (0, uuid_1.v4)();
        const dataToSubscribe = {
            id,
            key,
            func,
        };
        this.observers.push(dataToSubscribe);
        return () => {
            this.unsubscribe(id);
        };
    }
    unsubscribe(id) {
        this.observers = this.observers.filter((observer) => observer.id !== id);
    }
    notify(key, data) {
        this.observers
            .filter((o) => o.key == key)
            .forEach((o) => {
            // Observers are called for their side effects and nothing awaits them,
            // so an async observer that rejects would surface as an unhandled
            // rejection with no caller able to catch it. Report and carry on — one
            // failing observer must not stop the others from being notified.
            const report = (error) => {
                if (isDomainSignal(error))
                    throw error;
                console.error(`Observable: observer failed for ${key}`, error);
            };
            try {
                // Only observers that actually return a promise get one attached —
                // wrapping every call would allocate a promise and queue a microtask
                // for the synchronous majority, which notify() is hot enough to feel.
                const result = o.func(data);
                if (result && typeof result.then === "function") {
                    result.catch(report);
                }
            }
            catch (error) {
                report(error);
            }
        });
    }
}
exports.Observable = Observable;
